export default __webpack_public_path__ + "static/media/get-google.57967f41.svg";